 
 


//  import Navbar from "../components/Navbar";
// import ItemGrid from "../components/ItemGrid";
// import { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";

// function Home() {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [searchParams] = useSearchParams();
//   const search = searchParams.get("search") || "";

//   useEffect(() => {
//     const fetchItems = async () => {
//       try {
//         setLoading(true);

//         const user = JSON.parse(localStorage.getItem("user"));
//         const userCity = user?.city?.toLowerCase();

//         let url = "https://borrowhub-backend.onrender.com/api/items";
//         if (search && search.trim() !== "") {
//           url += `?search=${search}`;
//         }

//         const res = await fetch(url);
//         const data = await res.json();

//         // 🔥 Same logic: user city wale items pehle
//         const sortedItems = (data.items || []).sort((a, b) => {
//           if (a.location?.city?.toLowerCase() === userCity) return -1;
//           if (b.location?.city?.toLowerCase() === userCity) return 1;
//           return 0;
//         });

//         setItems(sortedItems);
//       } catch (err) {
//         console.error("fetchItems error", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchItems();
//   }, [search]);

//   return (
//     <>
//       {/* Navbar – simple, no notifications */}
//       <Navbar />

//       <div className="container-fluid mt-4">
//         <h2 className="fw-bold">Available Items</h2>
//         <p className="text-muted">
//           Browse items you can borrow from your community
//         </p>

//         {loading && <p>Loading items...</p>}

//         {!loading && items.length === 0 && (
//           <p>No items available</p>
//         )}

//         {!loading && items.length > 0 && (
//           <ItemGrid items={items} />
//         )}
//       </div>
//     </>
//   );
// }

// export default Home;








// import React, { useEffect, useState } from "react";
// import Navbar from "../components/Navbar";
// import { useNavigate } from "react-router-dom";
// import ProductCard from "../components/ProductCard";

// function Home() {
//   const navigate = useNavigate();
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [myLoc, setMyLoc] = useState(null); // Location status store karne ke liye

//   useEffect(() => {
//     // 1. Browser se Location maango
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const lat = position.coords.latitude;
//           const lng = position.coords.longitude;
//           setMyLoc({ lat, lng });
//           fetchSortedItems(lat, lng);
//         },
//         (error) => {
//           console.error("Loc Error:", error);
//           fetchSortedItems(null, null); // Location nahi mili, to normal fetch
//         }
//       );
//     } else {
//       fetchSortedItems(null, null);
//     }
//   }, []);

//   const fetchSortedItems = async (lat, lng) => {
//     try {
//       let url = "https://borrowhub-backend.onrender.com/api/items/nearby"; // Default API
      
//       // Agar location hai to query params lagao
//       if (lat && lng) {
//         url += `?lat=${lat}&lng=${lng}`;
//       }

//       const res = await fetch(url);
//       const data = await res.json();

//       if (data.success) {
//         setItems(data.items);
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper function: Meters ko KM me convert karne ke liye
//   const formatDist = (meters) => {
//     if (!meters) return "";
//     const km = (meters / 1000).toFixed(1); // 1200m -> 1.2 km
//     return `${km} km away`;
//   };

//   return (
//     <>
//       <Navbar />
      
//       {/* Hero Section */}
//       <div className="bg-light py-4 text-center mb-3">
//         <h2 className="fw-bold">Find Items Nearby 📍</h2>
//         <p className="text-muted">
//           {myLoc ? "Sorted by distance from you" : "Showing newest items (Enable location for sorting)"}
//         </p>
//       </div>

//       <div className="container pb-5">
//         {loading ? (
//           <div className="text-center mt-5"><div className="spinner-border text-success"></div></div>
//         ) : (
//           <div className="row g-4">
//             {items.map((item) => (
//               <div key={item._id} className="col-6 col-md-4 col-lg-3">
//                 <div 
//                   className="card h-100 shadow-sm border-0" 
//                   style={{cursor: "pointer", transition: "transform 0.2s"}}
//                   onClick={() => navigate(`/items/${item._id}`)}
//                 >
                  
//                   {/* Image */}
//                   <div style={{height: "180px", overflow: "hidden", position: "relative"}}>
//                     <img 
//                       src={item.images?.[0]?.url} 
//                       className="w-100 h-100 object-fit-cover" 
//                       alt={item.title} 
//                     />
//                     {/* 🔥 DISTANCE BADGE (Agar location on hai) */}
//                     {item.distance !== undefined && (
//                         <div className="position-absolute bottom-0 end-0 bg-dark text-white px-2 py-1 small fw-bold m-2 rounded opacity-75" style={{fontSize: "12px"}}>
//                            📍 {formatDist(item.distance)}
//                         </div>
//                     )}
//                   </div>

//                   {/* Body */}
//                   <div className="card-body p-3">
//                     <h6 className="fw-bold text-truncate mb-1">{item.title}</h6>
//                     <div className="d-flex justify-content-between align-items-center mt-2">
//                         <span className="badge bg-light text-dark border">₹{item.pricePerDay}/day</span>
//                     </div>
//                   </div>

//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default Home;




// import React, { useEffect, useState } from "react";
// import Navbar from "../components/Navbar";
// import { useNavigate } from "react-router-dom";
// import ProductCard from "../components/ProductCard";

// function Home() {
//   const navigate = useNavigate();
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [myLoc, setMyLoc] = useState(null);

//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const lat = position.coords.latitude;
//           const lng = position.coords.longitude;
//           setMyLoc({ lat, lng });
//           fetchItems(lat, lng);
//         },
//         (error) => {
//           console.error("Location error:", error);
//           fetchItems(null, null);
//         }
//       );
//     } else {
//       fetchItems(null, null);
//     }
//   }, []);

//   const fetchItems = async (lat, lng) => {
//     try {
//       let url = "https://borrowhub-backend.onrender.com/api/items/nearby";

//       // ✅ location mili to nearby sorting
//       if (lat && lng) {
//         url += `?lat=${lat}&lng=${lng}`;
//       }

//       const res = await fetch(url);
//       const data = await res.json();

//       if (data.success) {
//         setItems(data.items);
//       } else {
//         setItems([]);
//       }
//     } catch (err) {
//       console.error(err);
//       setItems([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // meters → km
//   const formatDist = (meters) => {
//     if (meters === undefined || meters === null) return "";
//     const km = (meters / 1000).toFixed(1);
//     return `${km} km away`;
//   };

//   return (
//     <>
//       <Navbar />

//       {/* Hero Section */}
//       <div className="bg-light py-4 text-center mb-3">
//         <h2 className="fw-bold">Find Items Nearby 📍</h2>
//         <p className="text-muted">
//           {myLoc
//             ? "Sorted by distance from you"
//             : "Showing newest items (Enable location for sorting)"}
//         </p>
//       </div>

//       <div className="container pb-5">
//         {loading ? (
//           <div className="text-center mt-5">
//             <div className="spinner-border text-success"></div>
//           </div>
//         ) : (
//           <div className="row g-4">
//             {items.map((item) => (
//               <div key={item._id} className="col-6 col-md-4 col-lg-3">
//                 <div
//                   className="card h-100 shadow-sm border-0"
//                   style={{
//                     cursor: "pointer",
//                     transition: "transform 0.2s",
//                   }}
//                   onClick={() => navigate(`/items/${item._id}`)}
//                 >
//                   {/* Image */}
//                   <div
//                     style={{
//                       height: "180px",
//                       overflow: "hidden",
//                       position: "relative",
//                     }}
//                   >
//                     <img
//                       src={
//                         item.images?.find((i) => i.isCover)?.url ||
//                         item.images?.[0]?.url
//                       }
//                       className="w-100 h-100 object-fit-cover"
//                       alt={item.title}
//                     />

//                     {/* 🔥 DISTANCE BADGE */}
//                     {item.distance !== undefined && (
//                       <div
//                         className="position-absolute bottom-0 end-0 bg-dark text-white px-2 py-1 small fw-bold m-2 rounded opacity-75"
//                         style={{ fontSize: "12px" }}
//                       >
//                         📍 {formatDist(item.distance)}
//                       </div>
//                     )}
//                   </div>

//                   {/* Body */}
//                   <div className="card-body p-3">
//                     <h6 className="fw-bold text-truncate mb-1">
//                       {item.title}
//                     </h6>
//                     <div className="d-flex justify-content-between align-items-center mt-2">
//                       <span className="badge bg-light text-dark border">
//                         ₹{item.pricePerDay}/day
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {items.length === 0 && (
//               <div className="text-center text-muted mt-5">
//                 No items found nearby 😕
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default Home;









// import React, { useEffect, useState } from "react";
// import Navbar from "../components/Navbar";
// import { useNavigate } from "react-router-dom";
// import ProductCard from "../components/ProductCard"; // 🔥 Naya Card Import kiya

// function Home() {
//   const navigate = useNavigate();
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [myLoc, setMyLoc] = useState(null); // Location status

//   useEffect(() => {
//     // 1. Browser se Location maango
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const lat = position.coords.latitude;
//           const lng = position.coords.longitude;
//           setMyLoc({ lat, lng });
//           fetchSortedItems(lat, lng);
//         },
//         (error) => {
//           console.error("Loc Error:", error);
//           // Location nahi mili to bhi items lao (Distance nahi dikhega bas)
//           fetchSortedItems(null, null); 
//         }
//       );
//     } else {
//       fetchSortedItems(null, null);
//     }
//   }, []);

//   const fetchSortedItems = async (lat, lng) => {
//     try {
//       let url = "https://borrowhub-backend.onrender.com/api/items/nearby"; // Tera Backend URL
      
//       // Agar location hai to query params lagao
//       if (lat && lng) {
//         url += `?lat=${lat}&lng=${lng}`;
//       }

//       const res = await fetch(url);
//       const data = await res.json();

//       if (data.success) {
//         setItems(data.items);
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />
      
//       {/* Hero Section */}
//       <div className="bg-light py-4 text-center mb-3 shadow-sm">
//         <h3 className="fw-bold text-success">BorrowHub 📦</h3>
//         <p className="text-muted small mb-0">
//           {myLoc ? "📍 Sorting items by distance from you" : "🌍 Showing newest items (Enable location for nearby)"}
//         </p>
//       </div>

//       <div className="container pb-5">
//         {loading ? (
//           <div className="text-center mt-5">
//              <div className="spinner-border text-success"></div>
//              <p className="mt-2 text-muted">Scanning nearby items...</p>
//           </div>
//         ) : (
//           <div className="row g-3"> {/* g-3 gap kam karega */}
//             {items.length === 0 ? (
//                 <div className="text-center w-100 mt-5">
//                     <h5>😕 No items found nearby.</h5>
//                     <p className="text-muted">Try increasing radius or add items yourself!</p>
//                 </div>
//             ) : (
//                 items.map((item) => (
//                   // 🔥 Grid Classes: Mobile pe 2, Desktop pe 4 cards
//                   <div key={item._id} className="col-6 col-md-4 col-lg-3">
//                     <ProductCard item={item} />
//                   </div>
//                 ))
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default Home;




import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { useNavigate, useSearchParams } from "react-router-dom"; // 🔥 searchParams add kiya
import ProductCard from "../components/ProductCard";

function Home() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // 🔥 URL se search nikalne ke liye
  const search = searchParams.get("search") || ""; // 🔥 Search term pakda

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [myLoc, setMyLoc] = useState(null);

  // 1. Browser se Location maango (Sirf ek baar start mein)
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setMyLoc({ lat, lng });
        },
        (error) => {
          console.error("Loc Error:", error);
          setMyLoc({ lat: null, lng: null }); // Location fail
        }
      );
    } else {
      setMyLoc({ lat: null, lng: null });
    }
  }, []);

  // 2. Jab bhi Location mile YA Search badle, items fetch karo 🔥
  useEffect(() => {
    if (myLoc !== null) {
      fetchSortedItems(myLoc.lat, myLoc.lng, search);
    }
  }, [myLoc, search]); // 🔥 search badalte hi ye wapas chalega

  const fetchSortedItems = async (lat, lng, searchQuery) => {
    try {
      setLoading(true); // Fetching shuru
       let url = "https://borrowhub-backend.onrender.com/api/items"; // 🔥 nearby hata de
      
      // ✅ Location and Search parameters
      const params = new URLSearchParams();
      if (lat && lng) {
        params.append("lat", lat);
        params.append("lng", lng);
      }
      if (searchQuery) {
        params.append("search", searchQuery); // 🔥 Backend ko search bheja
      }

      const res = await fetch(`${url}?${params.toString()}`);
      const data = await res.json();

      if (data.success) {
        setItems(data.items);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <div className="bg-light py-4 text-center mb-3 shadow-sm">
        <h3 className="fw-bold text-success">BorrowHub 📦</h3>
        <p className="text-muted small mb-0">
          {search ? `🔍 Searching for: "${search}"` : (myLoc?.lat ? "📍 Sorting items by distance from you" : "🌍 Showing newest items")}
        </p>
      </div>

      <div className="container pb-5">
        {loading ? (
          <div className="text-center mt-5">
             <div className="spinner-border text-success"></div>
             <p className="mt-2 text-muted">Searching items...</p>
          </div>
        ) : (
          <div className="row g-3"> 
            {items.length === 0 ? (
                <div className="text-center w-100 mt-5">
                    <h5>😕 No items found {search ? `for "${search}"` : "nearby"}.</h5>
                    <p className="text-muted">Try a different search or add items yourself!</p>
                </div>
            ) : (
                items.map((item) => (
                  <div key={item._id} className="col-6 col-md-4 col-lg-3">
                    <ProductCard item={item} />
                  </div>
                ))
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default Home;
